import {
    type SupportChatTouchpoint,
    type SettablePreChatFields,
    type PreChatFields,
} from '../types.ts';

function getPreChatFields({
    touchpoint,
    endUserId,
    isSellerChat,
    preChatFields: settablePreChatFields,
}: {
    touchpoint: SupportChatTouchpoint;
    endUserId: string | null | undefined;
    isSellerChat: boolean;
    preChatFields: SettablePreChatFields;
}): PreChatFields {
    const preChatFields: PreChatFields = {
        ...settablePreChatFields,
        ...(endUserId && { [isSellerChat ? 'dibsSellerId' : 'dibsUserId']: endUserId }),
        messageInitiator: isSellerChat ? 'Seller' : 'Buyer',
        touchpoint,
    };

    return preChatFields;
}

export { getPreChatFields };
